export const PLACEMENT_KIND = [
  { label: 'Квартиры', value: 'RESIDENTIAL' },
  // { label: 'Нежилые', value: 'NON_RESIDENTIAL' },
  { label: 'БКФН', value: 'BKFN' },
  { label: 'Кладовые', value: 'PANTRY' },
  { label: 'Машиноместа', value: 'PARKING' },
];
